// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.ant-spin-nested-loading > div > .ant-spin {\n  height: 100vh;\n}\n.ant-spin-nested-loading > div > .ant-spin .ant-spin-dot {\n  position: fixed;\n}\n", ""]);
// Exports
module.exports = exports;
